import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formPopupMarkPolicyNoteAsComplete_container: {
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupMarkPolicyNoteAsComplete_noteDetailsWrapper: {

		},
		formPopupMarkPolicyNoteAsComplete_noteDetails: {
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupMarkPolicyNoteAsComplete_noteSection: {
			display: 'flex',
			flexDirection: 'column',
			width: '100%',
		},
		formPopupMarkPolicyNoteAsComplete_inputWrapper: {
			padding: theme.spacing(2, 0),
		},
		formPopupMarkPolicyNoteAsComplete_label: {
			marginBottom: theme.spacing(2),
		},
	});
});

export default useStyles;
